import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import Modal from '../../UniformComponents/Modal'
import CheckboxGroup from '../form/CheckboxGroup'
import { sortBy } from '../../utils/helpers'

@observer
class ComparisonModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expanded: ['explori_general'],
            benchmarkValues: {},
        }
    }

    changeYears = ({ value }) => {
        const { dashStore } = this.props
        const { changeYears } = dashStore

        changeYears({ value: value.map((v) => ({ value: Number(v) })) })
    }

    changePeriods = ({ name }) => {
        const { dashStore } = this.props
        const { changeBenchmarkPeriod } = dashStore

        changeBenchmarkPeriod({ value: name })
    }

    changeBenchmarks = (section, { value }) => {
        const { dashStore } = this.props
        const { changeBenchmarks } = dashStore
        const { benchmarkValues } = this.state
        const newBenchmarkValues = { ...benchmarkValues, [section]: value }
        this.setState({ benchmarkValues: newBenchmarkValues })
        changeBenchmarks({ value: Object.values(newBenchmarkValues).flat(2).map((v) => ({ value: v })) })
    }

    setExpanded = (section) => {
        const { expanded } = this.state
        const isExpanded = expanded.includes(section)
        const el = this[`section_${section}`]

        if (isExpanded) {
            el.style.height = `${el.scrollHeight}px`
            window.requestAnimationFrame(() => {
                el.style.height = '0px'
            })
            this.setState({
                expanded: expanded.filter((s) => s !== section),
            })
        } else {
            el.style.height = '0px'
            const newExpanded = [...expanded, section]
            this.setState({ expanded: newExpanded }, () => {
                const fullHeight = el.scrollHeight
                el.style.height = `${fullHeight}px`
            })
        }
    }

    capitalizeFirstLetter = (str) => {
        if (!str) return ''
        return str.charAt(0).toUpperCase() + str.slice(1)
    }

    renderBenchmarks = () => {
        const { dashStore } = this.props
        const { langcode } = dashStore.appStore
        const { benchmarkTags, benchmarks } = dashStore
        const { expanded } = this.state
        return benchmarkTags.map(({
            customTagName, customTagConfig, tagOptions, parentConfig,
        }) => {
            const config = parentConfig || customTagConfig
            const parsedConfig = JSON.parse(config)
            if (!parsedConfig.benchmarkOptions.includes('publish')) return null
            const scopes = parsedConfig.benchmarkOptions.filter((scope) => scope !== 'publish')
            const scopeBenchmarks = scopes.map((scope) => {
                const benchmarkOptions = tagOptions.map((top) => {
                    const parsedTagConfig = JSON.parse(top.tagOptionConfig)
                    const tagName = R.pathOr(
                        R.pathOr(
                            R.pathOr('', ['langs', 'en_GB'], parsedTagConfig),
                            ['langs', langcode],
                            parsedTagConfig,
                        ),
                        ['name'], parsedTagConfig,
                    )
                    const value = top.tagOptionId
                    return { label: tagName, value: `${scope}_${value}` }
                })
                return (
                    <div>
                        <CheckboxGroup
                            name="benchmarks"
                            label={`${this.capitalizeFirstLetter(scope)} ${i18n.t('dashboard.benchmarksTitle')}`}
                            options={sortBy(
                                benchmarkOptions,
                                'value',
                            )}
                            defaultChecked={Array.from(benchmarks)
                                .filter((a) => !!a[1])
                                .map(([y]) => (y))}
                            onBlur={(value) => this.changeBenchmarks(customTagName, value)}
                            returnValueUnchanged
                        />
                    </div>
                )
            })
            return (
                <div className="benchmarkSection">
                    <h5
                        onClick={() => this.setExpanded(customTagName)}
                        style={{ cursor: 'pointer' }}
                    >
                        {customTagName}
                        {
                            expanded.includes(customTagName)
                                ? <i className="fa-solid fa-chevron-up" />
                                : <i className="fa-solid fa-chevron-down" />
                        }
                    </h5>
                    <div
                        className={`scopeBenchmarks ${expanded.includes(customTagName) ? 'expanded' : ''}`}
                        ref={(el) => { this[`section_${customTagName}`] = el }}
                    >
                        {scopeBenchmarks}
                    </div>
                </div>
            )
        })
    }

    render() {
        const { dashStore, showComparisonModal, toggleComparisonModal } = this.props
        const {
            years,
            benchmarks,
            benchmarkLabels,
            benchmarkPeriods,
            benchmarkPeriod,
            possibleBenchmarks,
            oId,
        } = dashStore
        const { expanded } = this.state

        return (
            <Modal show={showComparisonModal} onClose={toggleComparisonModal}>
                <div className="comparisonModal">
                    { benchmarks.size > 0 ? (
                        <>
                            <div className="benchmarks">
                                <label>{i18n.t('dashboard.benchmarksTitle')}</label>
                                <div className="benchmarkSection">
                                    <h5
                                        onClick={() => this.setExpanded('explori_general')}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {i18n.t('refcodes_General')}
                                        {
                                            expanded.includes('explori_general')
                                                ? <i className="fa-solid fa-chevron-up" />
                                                : <i className="fa-solid fa-chevron-down" />
                                        }
                                    </h5>
                                    <div
                                        className={`scopeBenchmarks ${expanded.includes('explori_general') ? 'expanded' : ''}`}
                                        ref={(el) => { this[`section_${'explori_general'}`] = el }}
                                    >
                                        <div>
                                            <CheckboxGroup
                                                name="benchmarks"
                                                label={i18n.t('dashboard.benchmarksTitle')}
                                                options={sortBy(
                                                    Array.from(benchmarks)
                                                        .map(([y]) => ({ label: benchmarkLabels[y], value: y })),
                                                    'value',
                                                ).filter((b) => possibleBenchmarks[oId].includes(b.value))}
                                                defaultChecked={Array.from(benchmarks)
                                                    .filter((a) => !!a[1])
                                                    .map(([y]) => (y))}
                                                onBlur={(value) => this.changeBenchmarks('explori_general', value)}
                                                returnValueUnchanged
                                            />
                                        </div>
                                    </div>
                                </div>
                                {this.renderBenchmarks()}
                            </div>
                            <div className="periods">
                                <CheckboxGroup
                                    name="periods"
                                    label={i18n.t('report_benchmark_period_label')}
                                    options={benchmarkPeriods}
                                    defaultChecked={benchmarkPeriod}
                                    radioValue={benchmarkPeriod}
                                    onBlur={this.changePeriods}
                                    radio
                                />
                            </div>
                        </>
                    ) : null }
                    <div className="years">
                        <CheckboxGroup
                            name="years"
                            label={i18n.t('powerpoint.labels.comparisonSurveyIds')}
                            options={sortBy(
                                Array.from(years)
                                    .map(([y]) => ({ label: y, value: y }))
                                    .filter((year) => (year.value >= 1900)),
                                'value', -1,
                            )}
                            defaultChecked={Array.from(years)
                                .filter((a) => !!a[1] && a[0] >= 1900)
                                .map(([y]) => y)}
                            onBlur={this.changeYears}
                            returnValueUnchanged
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ComparisonModal
